import React from 'react';
import { Link } from "react-router-dom";
import './card.scss';

export const CardButton = ({
    ariaLabel,
    borderStyle,
    children,
    className,
    disabled,
    href,
    to,
    target,
    onClick
}) => {

    const buttonCardClasses = [
        `bsw-card`,
        `bsw-card--button`,
        `bsw-card-border--${borderStyle}`,
        `${disabled ? 'bsw-card--disabled' : ''}`,
        `${className ? className : ''}`
    ].join(' ');

    const linkAs = disabled
        ? <div></div>
        : (to || href)
            ? (to
                ? <Link to={to} aria-label={ariaLabel}></Link>
                : <a href={href} aria-label={ariaLabel}></a>)
            : <button type="button"></button>

    const cardButtonElem = React.cloneElement(
        linkAs,
        {
            className: buttonCardClasses,
            onClick: onClick,
            target: target
        },
        children
    );
    return (
        <>
            {cardButtonElem}
        </>
    )
}